module.exports = __webpack_public_path__ + "img/public.c1535920.png";